<div class="refs-container">
    <frg-cards class="refs-card" [title]="pageTitle">
        <div class="inside-card-wrapper">
            <div class="types-wrapper">
                <frg-button
                    (activated)="search(refTypes['cim-10'])"
                    fullWidth="true"
                >CIM-10</frg-button>

                <frg-button
                    (activated)="search(refTypes['cisp-2'])"
                    fullWidth="true"
                >CISP 2</frg-button>

                <frg-button
                    (activated)="search(refTypes['ccam'])"
                    fullWidth="true"
                >CCAM</frg-button>

                <frg-button
                    (activated)="search(refTypes['atc'])"
                    fullWidth="true"
                >ATC</frg-button>

                <frg-button
                    (activated)="searchLoinc()"
                >LOINC</frg-button>
            </div>

            <div class="result-wrapper">
                <ng-container *ngIf="refsResult && refsResult.length > 0 && !isLoading">
                    <span class="ref-libelle" *ngFor="let ref of refsResult">{{ ref.id }} – {{ ref.libelle }}</span>
                </ng-container>

                <ng-container *ngIf="isLoading">
                    <div class="loader-wrapper">
                      <div class="lds-spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </frg-cards>
</div>